import { render, staticRenderFns } from "./Freight.vue?vue&type=template&id=4ccb8691&scoped=true&"
import script from "./Freight.vue?vue&type=script&lang=js&"
export * from "./Freight.vue?vue&type=script&lang=js&"
import style0 from "./Freight.vue?vue&type=style&index=0&id=4ccb8691&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb8691",
  null
  
)

export default component.exports